(function () {
    var commentsScript = document.querySelector('script[data-ghost-comments]');

    if (!commentsScript) {
        return;
    }

    var root = document.documentElement;
    var watchedRoot = null;
    var MODAL_STYLE_ID = 'comments-modal-scheme';

    function currentScheme() {
        return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    }

    function themeToken(name) {
        return getComputedStyle(root).getPropertyValue(name).trim();
    }

    function paintModalShell(frameDocument, scheme) {
        var style = frameDocument.getElementById(MODAL_STYLE_ID);

        if (scheme !== 'dark') {
            if (style) {
                style.remove();
            }
            return;
        }

        if (!style) {
            style = frameDocument.createElement('style');
            style.id = MODAL_STYLE_ID;
            frameDocument.head.appendChild(style);
        }

        style.textContent = [
            '[class*="shadow-modal"]{background-color:' + themeToken('--color-surface') + ' !important;}',
            '[class*="shadow-modal"] .text-black{color:' + themeToken('--color-text') + ' !important;}',
            '[class*="shadow-modal"] .text-neutral-500{color:' + themeToken('--color-text-soft') + ' !important;}'
        ].join('');
    }

    function paintFrameCanvas(frame, scheme) {
        var frameDocument;

        try {
            frameDocument = frame.contentDocument;
        } catch (error) {
            return;
        }

        if (!frameDocument || !frameDocument.documentElement) {
            return;
        }

        frameDocument.documentElement.style.colorScheme = scheme;
        frameDocument.documentElement.classList.toggle('dark', scheme === 'dark');
        paintModalShell(frameDocument, scheme);
    }

    function syncScheme() {
        var scheme = currentScheme();

        if (commentsScript.getAttribute('data-color-scheme') !== scheme) {
            commentsScript.setAttribute('data-color-scheme', scheme);
        }

        var commentsRoot = document.getElementById('ghost-comments-root');

        if (!commentsRoot) {
            return;
        }

        Array.prototype.forEach.call(commentsRoot.querySelectorAll('iframe'), function (frame) {
            paintFrameCanvas(frame, scheme);
            frame.addEventListener('load', function () {
                paintFrameCanvas(frame, currentScheme());
            });
        });

        if (!watchedRoot) {
            watchedRoot = commentsRoot;
            new MutationObserver(syncScheme).observe(commentsRoot, {childList: true, subtree: true});
        }
    }

    syncScheme();

    new MutationObserver(syncScheme).observe(root, {
        attributes: true,
        attributeFilter: ['data-theme']
    });

    new MutationObserver(syncScheme).observe(document.body, {childList: true, subtree: true});
})();
